export const appsJson = [
  {
    title: "App de Préstamos",
    description: `Una herramienta completa para gestionar préstamos fácil y rápido. En la nube, acceso en tiempo real desde cualquier lugar con internet.`,
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppPrestamos.png",
    points: [
      "Prestamos",
      "Cobranza",
      "Cajas",
      "Rutas",
      "Clientes",
      "Catálogos",
      "Roles",
      "Seguridad",
    ],
  },
  {
    title: "App Hoteles",
    description: `Aplicación de gestión hotelera que brinda una solución versátil y personalizable permitiendo administrar eficientemente sus operaciones.`,
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppHoteles.png",
    points: [
      "Check in",
      "Check Out",
      "Ventas",
      "Reservas",
      "Clientes",
      "Inventario",
      "Productos",
      "Administración",
      "Reportes",
    ],
  },
  {
    title: "App Financiera",
    description: `Una herramienta integral para la gestión eficiente de las finanzas empresariales. Consulta todos los movimientos en la nube, con acceso en tiempo real desde cualquier lugar con internet.`,
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppFinanciera.png",
    points: [
      "Ingresos",
      "Egresos",
      "Clientes",
      "Proveedores",
      "Pagos",
      "Costos",
      "Reportes",
      "Dashboard",
    ],
  },
  {
    title: "App Restaurante",
    description:
      "Obtén una solución completa que simplifica la operación diaria de tu restaurante.",
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppRestaurante.png",
    points: [
      "Comandas",
      "Mesas",
      "Productos",
      "Pedidos",
      "Compras",
      "Ventas",
      "Finanzas",
      "Reportes",
    ],
  },
  {
    title: "Venta en Ruta",
    description:
      "Optimiza rutas, simplifica la toma de pedidos y mantén un control preciso de tu negocio mientras estás en movimiento.",
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppVentaRuta.png",
    points: ["Ventas", "Pedidos", "Rutas", "Precios", "Vendedores", "Reportes"],
  },
  {
    title: "App Citas",
    description:
      "Reserva citas fácilmente, selecciona el servicio deseado y la disponibilidad horaria. Visualiza tu agenda, confirma citas y envía recordatorios automáticos a los clientes.",
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppCitas.png",
    points: [
      "Agenda",
      "Citas",
      "Ventas",
      "Clientes",
      "Catálogos",
      "Comisiones",
      "Finanzas",
    ],
  },
  {
    title: "Control de Inventarios",
    description:
      "Una herramienta dinámica y adaptable para gestionar de manera eficiente el stock. Permite registrar y monitorear en tiempo real el inventario, incluyendo productos, cantidades, ubicaciones y mucho más.",
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppInventarios.png",
    points: [
      "Pedidos",
      "Producción",
      "Inventario",
      "Compras",
      "Finanzas",
      "Auditoria",
      "Catálogos",
      "Finanzas",
    ],
  },
  {
    title: "CRM",
    description:
      "Lleva un registro de todas las oportunidades de venta y registra actividadades para llevar un correcto seguimiento de tus clientes.",
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppComody.png",
    points: ["Clientes", "Actividades", "Tratos", "Dashboard"],
  },
  {
    title: "App a la medida",
    description:
      "Creamos apps a la medida que se adaptan a las necesidades únicas de tu empresa, simplificando procesos, mejorando la eficiencia y centralizando la información clave.",
    image:
      "https://cursos-uniline.s3.us-west-1.amazonaws.com/apps/AppAMedida.png",
    points: [],
  },
];
